import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { logger } from '../logger';
import { Route } from '../route';
import { submitter } from '../submitter/submitter';
import { BMEventsType } from '../types';
import { BasePageLoadMetric } from './base-page-load-metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
import { WebVitalsMetric } from './web-vitals-metric';
export var PageLoadMetric = /*#__PURE__*/function (_BasePageLoadMetric) {
  _inherits(PageLoadMetric, _BasePageLoadMetric);
  var _super = _createSuper(PageLoadMetric);
  function PageLoadMetric() {
    _classCallCheck(this, PageLoadMetric);
    return _super.apply(this, arguments);
  }
  _createClass(PageLoadMetric, [{
    key: "startPageLoad",
    value: function startPageLoad() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isInitial: false
      };
      pageLoadMetaMetric.startPageLoad(_objectSpread(_objectSpread({}, params), {}, {
        cancelStarted: 'startTime' in params
      }));
      this.watchUntil();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$config$ssr;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stopTime = params.stopTime || window.performance.now();
      var pageLoadData = pageLoadMetaMetric.getDataToMerge();
      var metaMetricStopped = pageLoadMetaMetric.stop(params);
      if (!metaMetricStopped) {
        return false;
      }
      if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
        if (!this.marks[BasePageLoadMetric.FMP]) {
          var mark = SSRGetDoneMark.getDoneMark();
          if (mark) {
            pageLoadMetaMetric.markFMP(mark);
          }
        } else {
          pageLoadMetaMetric.markFMP(this.marks[BasePageLoadMetric.FMP]);
        }
      }
      this.route = Route.getRoute();
      var metricStopped = this.stopPageLoad(pageLoadData, _objectSpread(_objectSpread({}, params), {}, {
        stopTime: stopTime
      }));
      if (!metricStopped) {
        return false;
      }
      var data = this.getData();
      if (!this.config.virtual) {
        submitter.queue(data);
      }
      logger.logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
      this.enqueueWebVitals();
      return true;
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      pageLoadMetaMetric.mark(_mark, timestamp);
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      pageLoadMetaMetric.markFMP(timestamp);
    }
  }, {
    key: "getData",
    value: function getData() {
      var pageLoadMetaData = pageLoadMetaMetric.getData();
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PageLoadMetric.prototype), "getData", this).call(this)), {}, {
        // marks and explicitTimings are available only in pageLoadMeta
        marks: pageLoadMetaData.marks,
        explicitTimings: pageLoadMetaData.explicitTimings
      });
    }
  }, {
    key: "enqueueWebVitals",
    value: function () {
      var _enqueueWebVitals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _configChunk$BMEvents;
        var configChunk, webVitalMetric;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.config.virtual || !this.isInitial)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              _context.next = 4;
              return submitter.config.configChunk;
            case 4:
              configChunk = _context.sent;
              if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[BMEventsType.WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", false);
            case 7:
              webVitalMetric = new WebVitalsMetric({
                key: this.config.key,
                route: this.route,
                startTime: this.startTime,
                stopTime: this.stopTime,
                pageVisibleState: this.pageVisibleState
              });
              submitter.queue(webVitalMetric.getData());
              logger.logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
              return _context.abrupt("return", true);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function enqueueWebVitals() {
        return _enqueueWebVitals.apply(this, arguments);
      }
      return enqueueWebVitals;
    }()
  }]);
  return PageLoadMetric;
}(BasePageLoadMetric);